"use client"

import { externalAppId } from "@/config/consts"
import { useConfigParams } from "@/hooks/use-config-params"
import { Translate } from "../translate"
import { Button, ButtonProps } from "../ui/button"

export function BaseCloseButton({ onClick, ...rest }: ButtonProps) {
  const { channel, cancelCallbackUrl } = useConfigParams()

  const handleClick = () => {
    if (cancelCallbackUrl == null) {
      throw new Error("cancelCallbackUrl is not defined")
    }
    window.location.href = cancelCallbackUrl
  }

  if (externalAppId.includes(channel)) return null

  return (
    <Button onClick={onClick ?? handleClick} {...rest} variant="ghost">
      <Translate i18nKey={"SiteHeader.closeBtn"} />
    </Button>
  )
}
